import type { FooterLink } from "@/models/footerLinks.model";

export const FOOTER_LINKS: FooterLink[] = [
    {
        label: "Accessibility",
        url: "http://www.legalandgeneral.com/accessibility/",
    },
    {
        label: "Security",
        url: "http://www.legalandgeneral.com/security/",
    },
    {
        label: "Legal and regulatory",
        url: "http://www.legalandgeneral.com/legal-information/",
    },
    {
        label: "Privacy policy",
        url: "https://www.legalandgeneral.com/privacy-notice/",
    },
    {
        label: "Cookie Policy",
        isButton: true,
    },
];
